<template>
  <div id="signRecord" class="warp">
    <div class="head_search">
      <div style="margin-right: 20px">
        <el-button type="primary" size="mini" class="edit-button" @click="getList">
          查询
        </el-button>
        <el-button type="warning" size="mini" @click="resetEvent()">
          重置
        </el-button>
      </div>
      <div class="item_warp">
        <label style="width: 54px">手机号</label>
        <el-input
          v-model="userPhone"
          placeholder="请输入手机号"
          style="width: 150px"
          size="mini"
          clearable
        />
      </div>
    </div>

    <div class="table_warp">
      <el-table
        ref="gridTable"
        v-loading="loading"
        :data="tableData"
        border
        style="width: 1531px"
        height="calc(100vh - 320px )"
        size="mini"
      >
        <el-table-column prop="userPhone" label="用户" width="250">
          <template slot-scope="scope">
            <div>{{ scope.row.userPhone }}({{ scope.row.userName || '-' }})</div>
          </template>
        </el-table-column>
        <el-table-column prop="signDate" label="签到日期" width="180" />
        <el-table-column prop="continueDays" label="连续天数" width="180" />
        <el-table-column prop="rewardIssued" label="是否发券" width="160">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.rewardIssued ? '#67C23A' : '#909399' }">
              {{ scope.row.rewardIssued ? '是' : '否' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="rewardTicketName" label="奖励票券" width="300">
          <template slot-scope="scope">
            <span>{{ scope.row.rewardTicketName || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="rewardTicketNo" label="奖励票号" width="260">
          <template slot-scope="scope">
            <span>{{ scope.row.rewardTicketNo || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="创建时间" width="220">
          <template slot-scope="scope">
            {{
              $parseTime(new Date(scope.row.createdAt), '{y}-{m}-{d} {h}:{i}:{s}')
            }}
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageNumber"
      :limit.sync="pageSize"
      :page-sizes="[10, 20, 50, 100]"
      @pagination="next()"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { getSignRecordList } from '@/api/activity/signConfig'

export default {
  name: 'SignRecord',
  components: { Pagination },
  data() {
    return {
      pageNumber: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      userPhone: '',
      loading: false
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      const params = {
        pageNum: this.pageNumber,
        pageSize: this.pageSize,
        userPhone: this.userPhone
      }
      getSignRecordList(params)
        .then((res) => {
          this.tableData = res.rows || []
          this.total = res.count || 0
        })
        .catch((err) => {
          this.$message.error(err || '服务端异常，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },
    next() {
      this.$refs.gridTable.bodyWrapper.scrollTop = 0
      this.getList()
    },
    resetEvent() {
      this.userPhone = ''
      this.pageNumber = 1
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
#signRecord {
  .head_search {
    display: flex;
    width: 100%;
    margin-bottom: 20px;

    .item_warp {
      display: flex;
      align-items: center;

      label {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #525252;
        font-weight: 400;
      }
    }
  }
}
</style>
